// extracted by mini-css-extract-plugin
export default {"rating":"rR-z","numberOfStars":"sR-z","count":"tR-z","barGraphSpacing":"uR-z","barGraph":"vR-z"};